// extracted by mini-css-extract-plugin
module.exports = {"root":"d6tkDi","subTotal":"xv1kR_","totalSubLabel":"wFLqv9","disclaimer":"kWiKdk","totalSubLabelViewport":"meQfRB"};